import * as React from "react";
import { useEffect, useContext } from "react";
import petcozoolog from "../assets/petcozoolog.png";
import { Navigate } from "react-router-dom";
import { connect } from "react-redux";
import { Creators as CreatorsConfig } from "../store/ducks/config";
import SnackBar from "../components/SnackBarCustom";
import { useDispatch } from "react-redux";
import { CostoActions } from "../store/ducks/folios.js";
import { useSelector } from "react-redux";
import List from "@mui/material/List";
import { DatosCompradorContext } from "../context/Context.js";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { styles } from "../theme/styles";
import { Creators } from "../store/ducks/users";
import { usuariosValidos } from "../helpers/user.js";
import axios from "axios";

function MenuAppBar(props) {
  const {
    menu,
    logout,
    userData,
    clearMessage,
    message,
    redirectToPasswordScreen,
  } = props;
  const {
    correoCompradorContext,
    setCorreoCompradorContext,
    tiendaAsociadaContext,
    setTiendaAsociadaContext,
    rolContext,
    setRolContext,
    idGeneradoContext,
    setIdGeneradoContext,
    idbuscadoContext,
    setIdbuscadoContext,
    setTiendaAsociadaAuxiliarContext,
    tiendaAsociadaAuxiliarContext,
    setMostrarSelectTienda,
    mostrarSelectTienda,
  } = useContext(DatosCompradorContext);
  const dispatch = useDispatch();
  const costo = useSelector((state) => {});
  const getInfoUser = async () => {
    const infoUser = await axios.get(
      `${process.env.REACT_APP_APP_EMPLEADOS}/${userData.idNumber}`,
      {
        headers: {
          // ApiKey: "$Bhi!(FURsxzPo)$",
          ApiKey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
          Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
        },
      },
    );
    if (usuariosValidos.includes(userData.idNumber)) {
      if (userData.rol == "VENTA") {
        setTiendaAsociadaContext(infoUser.data.sucursal);
        setRolContext("VENDEDOR/A");
        setMostrarSelectTienda(false);
        setTiendaAsociadaAuxiliarContext(false);
      }
      if (userData.rol == "ADMIN") {
        setTiendaAsociadaContext(infoUser.data.sucursal);
        setRolContext("ADMIN");
        setMostrarSelectTienda(true);
        setTiendaAsociadaAuxiliarContext(true);
      }
    } else {
    }
  };

  useEffect(() => {
    if (userData.idNumber) {
      getInfoUser();
      setIdGeneradoContext("");
      setIdbuscadoContext("");
    }
  }, []);

  if (redirectToPasswordScreen) {
    return <Navigate to="/password" />;
  }

  return (
    <>
      <div style={styles.content}>
        <div style={styles.body}>
          <h1 style={{ ...styles.texth, marginBottom: "-5px" }}>
            Bienvenido {userData.name}
          </h1>
          <h1 style={styles.texth}> a PetcoZoo</h1>
          <div style={styles.logoContainer}>
            <img
              alt="Company Logo"
              src={petcozoolog}
              style={styles.logo}
              variant="rounded"
            />
          </div>
        </div>
      </div>
      {message ? (
        <SnackBar
          message={message.text}
          variant={message.type}
          open={message ? true : false}
          onClose={clearMessage}
          time={3000}
        />
      ) : null}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    menu: state.users.menu,
    userData: state.users.data,
    message: state.config.message,
    redirectToPasswordScreen: state.users.redirectToPasswordScreen,
  };
};

const creators = {
  logout: Creators.logout,
  clearMessage: CreatorsConfig.clearMessage,
};

export default connect(mapStateToProps, creators)(MenuAppBar);
